import { CREATE_MESSAGE } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function createMessage(state: State, action: Action): State {
	if (action.type !== CREATE_MESSAGE) {
		return state
	}

	return {
		...state,
		currentMessageProcess: action?.currentMessageProcess || null,
		messages: [
			...state.messages,
			{
				role: action.role,
				content: action.payload || '',
				id: action.id,
			},
		],
		conversationList: state.conversationList.map(conversation => {
			if (conversation.id === action.conversationId) {
				return {
					...conversation,
					updatedAt: action.newUpdatedAt,
				}
			}

			return conversation
		}),
	}
}
